import {
  Box,
  HStack,
  SimpleGrid,
  Skeleton,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

interface IAdminContentWrapper {
  children: React.ReactNode;
}

export const AdminContentWrapper: React.FC<IAdminContentWrapper> = ({
  children,
}) => {
  return (
    <Box
      overflowX="auto"
      overflowY="hidden"
      w="100%"
      css={{
        '&::-webkit-scrollbar': {
          height: '6px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#c1c1c1',
          borderRadius: '8px',
        },
        scrollbarWidth: 'thin',
        scrollbarColor: '#c1c1c1 transparent',
      }}
    >
      {children}
    </Box>
  );
};

export const AdminSummary: React.FC<{
  items: { label: string; value: string | number }[];
  loading?: boolean;
}> = ({ items, loading = false }) => {
  const surface = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'gray.600');
  const muted = useColorModeValue('gray.600', 'gray.300');
  return (
    <SimpleGrid columns={{ base: 2, md: items.length }} spacing={3}>
      {items.map(({ label, value }) => (
        <Box
          key={label}
          bg={surface}
          borderWidth="1px"
          borderColor={border}
          borderRadius="lg"
          p={4}
        >
          <Text fontSize="sm" color={muted} mb={2}>
            {label}
          </Text>
          <Skeleton isLoaded={!loading}>
            <HStack>
              <Text fontSize="2xl" fontWeight="bold" lineHeight="short">
                {value}
              </Text>
            </HStack>
          </Skeleton>
        </Box>
      ))}
    </SimpleGrid>
  );
};
